import React from 'react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { IDropdownOption } from '@fluentui/react';
import { Controller, UseFormMethods } from 'react-hook-form';
import IDropdownReference from '../../../utils/types/IDropdownReference';
import { IEntityTerminationReviewApproval } from '../types';
import LifecycleStatusDropdown from '../../common/formFields/LifecycleStatusDropdown';

interface IEntityTerminationReviewRejectFormProps {
  form: UseFormMethods<IEntityTerminationReviewApproval>;
  data: IEntityTerminationReviewApproval;
}

const EntityTerminationReviewRejectForm = ({
  form,
  data,
}: IEntityTerminationReviewRejectFormProps) => {
  const { control, setValue, getValues } = form;

  const onLifecycleStatusChange = (value: IDropdownOption): void => {
    setValue('lifecycleStatus', value);
  };

  return (
    <Stack tokens={{ childrenGap: 10 }}>
      <Controller
        name="lifecycleStatus"
        label="Lifecycle Status"
        valueKey="lifecycleStatus"
        control={control}
        render={(props: { value: IDropdownReference }) => {
          return (
            <LifecycleStatusDropdown
              label="Lifecycle Status"
              valueKey="lifecycleStatus"
              required
              handleChange={onLifecycleStatusChange}
              value={props.value}
              selectableFieldNames={['TBD', 'Operating', 'Accounting Ledger Only']}
            />
          );
        }}
        rules={{
          validate: () => {
            const lifecycleStatus = getValues('lifecycleStatus') as IDropdownReference | undefined;
            if (!lifecycleStatus?.fieldName?.trim()) {
              return 'Please select a Lifecycle Status.';
            }
            return null;
          },
        }}
      />
    </Stack>
  );
};

export default EntityTerminationReviewRejectForm;
